
import { initializeApp } from "firebase/app";
import{ getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"



const firebaseConfig = {
  apiKey: "AIzaSyA2HI8njFalKPm9p0gDEc05f8R6LvQL6og",
  authDomain: "tgpl-751c9.firebaseapp.com",
  projectId: "tgpl-751c9",
  storageBucket: "tgpl-751c9.firebasestorage.app",
  messagingSenderId: "864723926005",
  appId: "1:864723926005:web:d4eb088876c8f496bbbebc"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);


export async function refreshToken(){
 let refresh = await getAuth().currentUser.getIdToken(/* forceRefresh */ true)

    return refresh
 
}